import fire from "@assets/img/png/fire.png";
import styles from "./styles.module.scss";

export const CalorieCounter = () => {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <img src={fire} alt="" />
        <p>AI calorie counter included in subscription</p>
      </div>
    </div>
  );
};
